<template>
  <div class="institutional-users">
    <div class="container">
      <div class="card">
        <NavTabs
          :tabs="['Profissionais de saúde', 'Conveniados']"
          :selected="selected"
          @selected="setSelectedTab"
        >
          <Tab :is-selected="selected === 'Profissionais de saúde'">
            <div v-if="doctors.length" class="institutional-users__group">
              <div
                class="institutional-users__group-item"
                v-for="doctor in doctors"
                :key="doctor.id"
              >
                <div class="institutional-users__card-column">
                  <div class="institutional-users__card-avatar">
                    <div
                      class="institutional-users__card-avatar-image"
                      :style="userPhoto(doctor.user.photo)"
                    />
                  </div>

                  <div class="institutional-users__card-infor">
                    <h6 class="institutional-users__card-infor-name">
                      {{ doctor.user.name }}
                    </h6>
                    <span>
                      <Icon :name="'envelope-icon'" :width="16" :height="16" />
                      {{ doctor.user.email }}
                    </span>
                    <span class="institutional-users__card-line" />
                    <span>
                      <Icon :name="'telephone-icon'" :width="16" :height="16" />
                      {{ doctor.user.phone }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="institutional-users__empty">
              <h6>Nenhum profisisonal de saúde cadastrado.</h6>
            </div>
          </Tab>

          <Tab :is-selected="selected === 'Conveniados'">
            <div v-if="patients.length" class="institutional-users__group">
              <div
                class="institutional-users__group-item"
                v-for="patient in patients"
                :key="patient.id"
              >
                <div class="institutional-users__card-column">
                  <div class="institutional-users__card-avatar">
                    <div
                      class="institutional-users__card-avatar-image"
                      :style="userPhoto(patient.user.photo)"
                    />
                  </div>

                  <div class="institutional-users__card-infor">
                    <h6 class="institutional-users__card-infor-name">
                      {{ patient.user.name }}
                    </h6>
                    <span>
                      <Icon :name="'envelope-icon'" :width="16" :height="16" />
                      {{ patient.user.email }}
                    </span>
                    <span class="institutional-users__card-line" />
                    <span>
                      <Icon :name="'telephone-icon'" :width="16" :height="16" />
                      {{ patient.user.phone }}
                    </span>
                    <span>
                      <button
                        class="institutional-users__details-button"
                        @click.prevent="showModal(patient)"
                      >
                        Ver detalhes
                      </button>
                    </span>
                  </div>
                </div>
                <div>
                  <b-form-select
                    v-model="patient.user.status"
                    :options="options"
                    @change="handleStatusChange($event, patient)"
                  />
                </div>
              </div>
            </div>

            <div v-else class="institutional-users__empty">
              <h6>Nenhum paciente cadastrado.</h6>
            </div>
          </Tab>
        </NavTabs>
      </div>
      <BModal ref="med-record" size="xl" hide-footer hide-header>
        <MedicalRecord :record-data="recordData" />
      </BModal>
      <Loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
  </div>
</template>

<script>
import { operatorMethods, userMethods, userComputed } from "./../state/helpers";
import NavTabs from "../components/NavTabs";
import Tab from "../components/Tab";
import Loading from "vue-loading-overlay";
import Icon from "../components/CustomIcons";
import MedicalRecord from "../components/MedicalRecord.vue";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "InstitutionalUsers",
  components: {
    NavTabs,
    Tab,
    Loading,
    Icon,
    MedicalRecord
  },
  data() {
    return {
      selected: "Profissionais de saúde",
      doctors: [],
      patients: [],
      loading: false,
      recordData: {
        symptoms: [],
        patient: {},
        observation: undefined,
        last_appointment: null
      },
      options: [
        {
          value: "no_restriction",
          text: "S/ restrições"
        },
        {
          value: "social_isolation",
          text: "Isolamento social"
        },
        {
          value: "suspected_of_contamination",
          text: "Suspeita de contaminação"
        },
        {
          value: "death",
          text: "Óbito"
        }
      ],
      error: null
    };
  },
  async mounted() {
    this.loading = true;
    await this.fetchUserInstitutions("doctor").then(resp => {
      this.doctors = resp.data;
    });

    await this.fetchUserInstitutions("patient").then(resp => {
      this.patients = resp.data;
      this.loading = false;
    });
  },
  methods: {
    ...operatorMethods,
    ...userMethods,
    setSelectedTab(tab) {
      this.selected = tab;
    },
    userPhoto(photo) {
      return photo
        ? `background-image: url(${photo});`
        : `background-image: url(${require("./../assets/images/doctor-img.jpg")});`;
    },
    handleStatusChange(event, patient) {
      const patch = [...this.patients];
      const index = patch.findIndex(user => user.id === patient.id);
      patch[index].user.status = event;
      this.patients = patch;
      this.updateUserStatus(patch[index]).then(async response => {
        this.loading = true;
        await this.fetchUserInstitutions("patient").then(resp => {
          this.loading = false;
          this.patients = resp.data;
        });
      });
    },
    showModal(data) {
      this.loading = true;
      this.patient = data.patient;
      this.fetchUserInstitutionSymptoms(data.user.id)
        .then(response => {
          this.recordData.symptoms = response.data.symptoms;
          this.recordData.patient = response.data.user;
          this.recordData.observation = response.data.observation;
          this.recordData.last_appointment = response.data.last_appointment;
          this.loading = false;
          this.$refs["med-record"].show();
        })
        .catch(error => {
          this.loading = false;
          this.error = error;
        });
    },
    hideModal() {
      this.symptoms = [];
      this.patient = null;
      this.$refs["med-record"].hide();
    }
  }
};
</script>
